export default __webpack_public_path__ + "src/images/btn_close_green-c55b1a.png";